import { Component, inject, OnInit } from '@angular/core';
import { NamedDialog, AppConfig, DialogComponent } from '@tytapp/common';
import { GiftsApi } from '@tytapp/api';
import { ApiGiftItem } from '@tytapp/api';
import { Router } from '@angular/router';
import { Redirection } from 'common/redirection';
import { environment } from '@tytapp/environment';

@NamedDialog('redeem')
@Component({
    selector: 'tyt-redemption',
    templateUrl: './redemption.component.html',
    styleUrls: ['./redemption.component.scss']
})
export class RedemptionComponent extends DialogComponent implements OnInit {
    private giftsApi = inject(GiftsApi);

    code: string;
    error: string;
    giftItem: ApiGiftItem;

    get accountsUrl() {
        return environment.urls.accounts;
    }

    async redeem() {
        if (!this.code) {
            return;
        }

        try {
            this.giftItem = await this.giftsApi.getGiftItem(this.code).toPromise();
            if (this.giftItem.purchased_quantity === this.giftItem.redemptions_count) {
                this.error = 'This code is no longer valid';
            } else {
                this.redirection.go(`${this.accountsUrl}/gift/redemption/${this.code}`);
            }
        } catch (e) {
            this.error = 'This code is no longer valid';
        }

    }

}
